/**
 * Controla o menu que exibe os locations por locationType no mapa.
 *
 * @author: Jordão Macedo
 * Date: 02/27/19
 */



Greenmile.Toolbar = Greenmile.Toolbar || {};
Greenmile.Toolbar.Map = Greenmile.Toolbar.Map || {};
Greenmile.Toolbar.Map.GeofencesControl = Greenmile.Toolbar.Map.GeofencesControl || {};

Greenmile.Toolbar.Map.GeofencesControl = function (selector, map) {

    this.map = map;

    this.addListeners = function () {
        const listGeofenceSelector = selector + " .geofencesList",
            listGeofence = document.querySelector(listGeofenceSelector + " > li");

        listGeofence.className = "tagsContainer tagsGeofence";
        var layer = new Greenmile.Toolbar.Map.Tags(map, selector, new Greenmile.Toolbar.Map.TagsGeofenceActions(map, selector));
        layer.render();
    };

};
